import httpClient from '../http';
import { API_ENDPOINTS } from '../config';
export const tutorialCategoriesApi = {
    list: () => httpClient.get(API_ENDPOINTS.TUTORIAL_CATEGORIES.LIST),
    all: () => httpClient.get(API_ENDPOINTS.TUTORIAL_CATEGORIES.ALL),
    create: (data) => httpClient.post(API_ENDPOINTS.TUTORIAL_CATEGORIES.CREATE, data),
    update: (data) => httpClient.put(API_ENDPOINTS.TUTORIAL_CATEGORIES.UPDATE, data),
    delete: (id) => httpClient.delete(API_ENDPOINTS.TUTORIAL_CATEGORIES.DELETE, { data: { id } }),
    toggle: (id) => httpClient.put(API_ENDPOINTS.TUTORIAL_CATEGORIES.TOGGLE, { id })
};
